const typesLivraison = new Map()
typesLivraison.set('SERVICE_AUTO', "Service à l'auto")
typesLivraison.set('LIVRAISON_ETABLISSEMENT', "Livraison à l'établissement")
typesLivraison.set('LIVRAISON_SUCCURSALE', 'Livraison en succursale')

const journeesLivraison = new Map()
journeesLivraison.set('LUNDI', 'Lundi')
journeesLivraison.set('MARDI', 'Mardi')
journeesLivraison.set('MERCREDI', 'Mercredi')
journeesLivraison.set('JEUDI', 'Jeudi')
journeesLivraison.set('VENDREDI', 'Vendredi')
journeesLivraison.set('SAMEDI', 'Samedi')
journeesLivraison.set('DIMANCHE', 'Dimanche')
journeesLivraison.set('LUNDI_MARDI', 'Lundi et mardi')
journeesLivraison.set('LUNDI_MERCREDI', 'Lundi et mercredi')
journeesLivraison.set('LUNDI_JEUDI', 'Lundi et jeudi')
journeesLivraison.set('LUNDI_VENDREDI', 'Lundi et vendredi')
journeesLivraison.set('MARDI_MERCREDI', 'Mardi et mercredi')
journeesLivraison.set('MARDI_JEUDI', 'Mardi et jeudi')
journeesLivraison.set('MARDI_VENDREDI', 'Mardi et vendredi')
journeesLivraison.set('MERCREDI_JEUDI', 'Mercredi et jeudi')
journeesLivraison.set('MERCREDI_VENDREDI', 'Mercredi et vendredi')
journeesLivraison.set('JEUDI_VENDREDI', 'Jeudi et vendredi')

const statutsDemande = new Map()
statutsDemande.set('BROUILLON', 'Brouillon')
statutsDemande.set('NOUVELLE_DEMANDE', 'Transmis')
statutsDemande.set('EN_TRAITEMENT', 'En traitement')
statutsDemande.set('VEROUILLEE', 'En traitement')
statutsDemande.set('EN_ATTENTE_MODIFICATION_CLIENT', 'En traitement')
statutsDemande.set('COMPLETEE', 'En traitement')
statutsDemande.set('ANNULEE', 'Annulée')
statutsDemande.set('EN_ATTENTE_BON_COMMANDE', 'En traitement')
statutsDemande.set('BON_COMMANDE_EMIS', 'Bon de commande émis')
statutsDemande.set('TRANSMIS', 'Transmis')

const statutsDemandeRecherche = new Map()
statutsDemandeRecherche.set('BROUILLON', 'Brouillon')
statutsDemandeRecherche.set('NOUVELLE_DEMANDE', 'Nouvelle demande')
statutsDemandeRecherche.set('EN_TRAITEMENT', 'En traitement')
statutsDemandeRecherche.set('COMPLETEE', 'Complétée')
statutsDemandeRecherche.set('ANNULEE', 'Annulée')
statutsDemandeRecherche.set('BON_COMMANDE_EMIS', 'Bon de commande émis')

const statutsCommandeIP = new Map()
statutsCommandeIP.set('BROUILLON', 'Brouillon')
statutsCommandeIP.set('EN_ATTENTE_TRAITEMENT', 'En attente de traitement')
statutsCommandeIP.set('EN_TRAITEMENT', 'En traitement')
statutsCommandeIP.set('CONFIRMEE', 'Confirmée')
statutsCommandeIP.set('REJETEE', 'Rejetée')
statutsCommandeIP.set('ANNULEE', 'Annulée')

const typesClient = new Map()
typesClient.set('TITULAIRE_POUR_REVENTE', 'Titulaire pour revente')
typesClient.set('AGENT_PROMOTIONNEL', 'Agent promotionnel')
typesClient.set('PART_USAGE_PERSONNEL', 'Particulier usager personnel')
typesClient.set('BOUTIQUE_HORS_TAXE', 'Boutique hors taxe')
typesClient.set('POUVOYEUR_DE_NAVIRE', 'Pourvoyeur de navire')
typesClient.set('LIEU_DE_CULTE', 'Lieu de culte')
typesClient.set(
  'GROUPE_ACHAT_OU_CLUB_OENOPHILE',
  'Groupe achat ou club oenophile'
)

// TODO DF: mettre les bonnes valeurs
const typesClientJDE = new Map()
typesClientJDE.set('01', 'Titulaire pour revente')
typesClientJDE.set('10', 'Agent promotionnel')
typesClientJDE.set('02', 'Particulier usage personnel')
typesClientJDE.set('98', 'Boutique hors taxe')
typesClientJDE.set('97', 'Pourvoyeur de navire')
typesClientJDE.set('96', 'Lieu de culte')
typesClientJDE.set('03', 'Groupe achat ou club oenophile')

const statutsCommandeTP = new Map()
statutsCommandeTP.set('EN_ATTENTE_TRAITEMENT', 'En attente de traitement')
statutsCommandeTP.set('EN_TRAITEMENT', 'En traitement')
statutsCommandeTP.set('CONFIRMEE', 'Confirmée')
statutsCommandeTP.set('REJETEE', 'Rejetée')
statutsCommandeTP.set('ANNULEE', 'Annulée')
statutsCommandeTP.set('EN_ATTENTE_RETOUR_CLIENT', 'En attente de retour client')

const typesCarteCredit = new Map()
typesCarteCredit.set('VISA', 'Visa')
typesCarteCredit.set('MASTER_CARD', 'Master card')
typesCarteCredit.set('AMERICAN_EXPRESS', 'American expresss')

const typesDepot = new Map()
typesDepot.set('CARTE_CREDIT', 'Carte de crédit')
typesDepot.set('CAPACITE_FINANCIERE', 'Capacité financière')

const formatsBouteille = new Map()
formatsBouteille.set('MILLILITRE', 'ML')
formatsBouteille.set('LITRE', 'L')

const devise = new Map()
devise.set('CAD', 'CAD')
devise.set('USD', 'USD')
devise.set('XEU', 'EURO')

const typePrix = new Map()
typePrix.set('PRIX_FOURNISSEUR', 'Fournisseur (à la caisse)')
typePrix.set('PRIX_DETAIL', 'Vente à la bouteille')

const termeAchat = new Map()
termeAchat.set(
  'FCA',
  "Terme d'achat FCA - transport assuré par la SAQ à partir du lieu d'enlèvement désigné par la SAQ"
)
termeAchat.set(
  'DDU',
  "Terme d'achat DDU - transport assuré par avion par le fournisseur"
)

const typeContenant = new Map()
typeContenant.set('AC', "Acier")
typeContenant.set('AL', 'Aluminium')
typeContenant.set('AS', 'Aseptique tetrapack (carton multicouche)')
typeContenant.set('CE', 'Céramique / Porcelaine / Grès')
typeContenant.set('CR', 'Cristal')
typeContenant.set('HD', 'Plastique HDPE (code recyc.#2)')
typeContenant.set('LD', 'Plastique LDPE (code recyc.#4)')
typeContenant.set('P3', 'Plastique vinyle / PVC (code recyc. #3)')
typeContenant.set('P5', 'Plastique PP (code recyc. #5)')
typeContenant.set('P6', 'Plastique polystyrène (code recyc. #6)')
typeContenant.set('P7', 'Plastique PLA / biosourcé / dégradable (code recyc. #7)')
typeContenant.set('PA', 'Plastiques autres (sans code recyc.)')
typeContenant.set('PE', 'Plastique PET (code recyc. #1)')
typeContenant.set('PS', 'Plastique stratifié (poche multicouche)')
typeContenant.set('V1', 'Vinier BIB (carton et plastique stratifié)')
typeContenant.set('VL', 'Verre clair')
typeContenant.set('VO', 'Verre coloré')
typeContenant.set('NA', 'Non applicable')

//typeContenant.set('V2', 'Carton (vinier) 10L')
//typeContenant.set('V4', 'Carton (vinier) 4L')
//typeContenant.set('V5', 'Carton (vinier) + de 10L')
//typeContenant.set('CP', 'Carton ond./Plast. strat. 20L')
//typeContenant.set('KS', 'Kit shooter')

const typeContenantConfirmation = new Map()
typeContenantConfirmation.set('AC', "Acier")
typeContenantConfirmation.set('AL', 'Aluminium')
typeContenantConfirmation.set('AS', 'Aseptique tetrapack (carton multicouche)')
typeContenantConfirmation.set('CE', 'Céramique / Porcelaine / Grès')
typeContenantConfirmation.set('CR', 'Cristal')
typeContenantConfirmation.set('HD', 'Plastique HDPE (code recyc.#2)')
typeContenantConfirmation.set('LD', 'Plastique LDPE (code recyc.#4)')
typeContenantConfirmation.set('P3', 'Plastique vinyle / PVC (code recyc. #3)')
typeContenantConfirmation.set('P5', 'Plastique PP (code recyc. #5)')
typeContenantConfirmation.set('P6', 'Plastique polystyrène (code recyc. #6)')
typeContenantConfirmation.set('P7', 'Plastique PLA / biosourcé / dégradable (code recyc. #7)')
typeContenantConfirmation.set('PA', 'Plastiques autres (sans code recyc.)')
typeContenantConfirmation.set('PE', 'Plastique PET (code recyc. #1)')
typeContenantConfirmation.set('PS', 'Plastique stratifié (poche multicouche)')
typeContenantConfirmation.set('V1', 'Vinier BIB (carton et plastique stratifié)')
typeContenantConfirmation.set('VL', 'Verre clair')
typeContenantConfirmation.set('VO', 'Verre coloré')
typeContenantConfirmation.set('NA', 'Non applicable')
typeContenantConfirmation.set('V2', 'Carton (vinier) 10L')
typeContenantConfirmation.set('V4', 'Carton (vinier) 4L')
typeContenantConfirmation.set('V5', 'Carton (vinier) + de 10L')
typeContenantConfirmation.set('CP', 'Carton ond./Plast. strat. 20L')
typeContenantConfirmation.set('KS', 'Kit shooter')

const typeBouchon = new Map()
typeBouchon.set('COURONNE_METALLIQUE', 'Couronne métallique')
typeBouchon.set('COURONNE_METALIQUE_VISSEE', 'Couronne métallique vissée')
typeBouchon.set('LANGUETTE', 'Languette')
typeBouchon.set('LIEGE', 'Liège')
typeBouchon.set('LIEGE_TETE_PLASTIQUE', 'Liège avec tête de plastique')
typeBouchon.set('LIEGE_TETE_BOIS', 'Liège avec tête en bois')
typeBouchon.set('LIEGE_TETE_METAL', 'Liège avec tête en métal')
typeBouchon.set('METAL_VISEE', 'Métal vissé')
typeBouchon.set('NON_APPLICABLE', "Ne s'applique pas")
typeBouchon.set('PLASTIQUE_MOUSSEUX', 'Plastique (mousseux)')
typeBouchon.set('PLASTIQUE_TETE_PLASTIQUE', 'Plastique avec tête plastique')
typeBouchon.set('PLASTIQUE_VISSE', 'Plastique vissé')
typeBouchon.set('PROCELAINE', 'Porcelaine')
typeBouchon.set('SYNTHETIQUE', 'Synthétique ext. tire-bouchon')
typeBouchon.set('VALVE', 'Valve')
typeBouchon.set('VERRE', 'Verre')

const notesTP = new Map()
notesTP.set('CARTE_CREDIT_REFUSEE', 'Carte de crédit refusée')
notesTP.set('LIMITE_CREDIT_REFUSEE', 'Limite de crédit dépassée')
notesTP.set('CHANGEMENT_LIVRAISON', 'Changement aux instructions de livraison')

const raisonAnnulationTP = new Map()
raisonAnnulationTP.set('DEMANDE_CLIENT', 'À la demande du client')
raisonAnnulationTP.set('AUCUN_RETOUR_CLIENT', 'Aucun retour du client')
raisonAnnulationTP.set('CLIENT_ARRET_VENTE', 'Client en arrêt de vente')

const moisDansAnnee = new Map()
moisDansAnnee.set('01', 'Janvier')
moisDansAnnee.set('02', 'Février')
moisDansAnnee.set('03', 'Mars')
moisDansAnnee.set('04', 'Avril')
moisDansAnnee.set('05', 'Mai')
moisDansAnnee.set('06', 'Juin')
moisDansAnnee.set('07', 'Juillet')
moisDansAnnee.set('08', 'Août')
moisDansAnnee.set('09', 'Septembre')
moisDansAnnee.set('10', 'Octobre')
moisDansAnnee.set('11', 'Novembre')
moisDansAnnee.set('12', 'Décembre')

const annneeDisponible = new Map()
annneeDisponible.set('01', 'Année en cours')
annneeDisponible.set('02', 'Année précédente')

export {
  annneeDisponible, devise, formatsBouteille, journeesLivraison, moisDansAnnee, notesTP,
  raisonAnnulationTP, statutsCommandeIP, statutsCommandeTP, statutsDemande, statutsDemandeRecherche, termeAchat, typeBouchon, typeContenant, typeContenantConfirmation, typePrix, typesCarteCredit, typesClient,
  typesClientJDE, typesDepot, typesLivraison
}

